import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { ElevatedGreenButton } from "../../../../../Components/Button/CustomButton";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  ActivateIcon,
  AwardIcon,
  ColumnTextStyle,
  DeactivateIcon,
  EditIcon,
  ViewIcon,
} from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import StatusGenerator from "../../../../../Components/StatusGenerator/StatusGenerator";
import Page from "../../../../../Components/Dashboard/Page";
import DataTable from "../../../../../Components/Table/DataTable";
import CardAllUsers from "../../../../../sections/@dashboard/app/CardAllUsers";
import Forms from "../../../../../Components/UserManagement/Forms";
import Modal from "../../../../../Components/DialogBox/Modal";
import UserDialog from "../../../../../Components/UserManagement/UserDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  disengageLGI,
  engageLGI,
  fetchAllLGIUsers,
  fetchStates,
  registerLGIUser,
  relocateLGI,
  resetPassword,
  restoreLGIUser,
} from "../../../../../Actions";
import validators from "../../../../../Utils/Validators";
import { useDebounce } from "../../../../../Hooks/useDebounce";
import ConfirmDialog from "../../../../../Components/Alert/ConfirmDialog";
import { colors } from "../../../../../Styles/GlobalStyles/Variables";
import AlertDialog from "../../../../../Components/Alert/AlertDialog";

const getLGIState = (state) => state.usersReducer;

const UserManagement = () => {
  const initialFormValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    stateId: 0,
    lgaId: "",
    staffNo: "",
  };
  const { statesfetched } = useSelector((state) => state.statesReducer);
  const {
    registeringLGI,
    registeredLGI,
    fetchingLGIUsers,
    LGIUsers,
    authUser,
    relocatingLGI,
    relocatedLGI,
    lgiActivated,
    activatingLGI,
    lgiDeactivated,
    deactivatingLGI,
    passwordReset,
    resettingPassword,
  } = useSelector(getLGIState);

  const [formValues, setFormValues] = useState({ ...initialFormValues });
  const [isView, setIsView] = useState(false);
  const dispatch = useDispatch();
  const initialFormErrStates = {
    stateIdErr: false,
    stateIdErrText: "",
    lgaIdErr: false,
    lgaIdErrText: "",
    firstNameErr: false,
    firstNameErrText: "",
    lastNameErr: false,
    lastNameErrText: "",
    staffNoErr: false,
    staffNoErrText: "",
    phoneNumberErr: false,
    phoneNumberErrText: "",
    emailErr: false,
    emailErrText: "",
  };
  const initialRelocationErrStates = {
    stateIdErr: false,
    stateIdErrText: "",
    lgaIdErr: false,
    lgaIdErrText: "",
  };
  const initialFormValuesRelocate = {
    userId: "",
    lgaId: "",
    stateId: 0,
    currentState: "",
  };
  const [open, setOpen] = useState(false);
  const [openRelocateDialog, setOpenRelocateDialog] = useState(false);
  const [formValuesRelocate, setFormValuesRelocate] = React.useState({
    ...initialFormValuesRelocate,
  });
  const [stateValue, setStateValue] = React.useState({ title: "", value: "" });
  const [selectedStateValue, setSelectedStateValue] = React.useState({
    title: "",
    value: "",
  });
  const [selectedLgaValue, setSelectedLgaValue] = React.useState({
    title: "",
    value: "",
  });
  const [lgaValue, setLgaValue] = React.useState({ title: "", value: "" });
  const [error, setError] = React.useState({ ...initialFormErrStates });
  const [newErr, setNewErr] = React.useState({ ...initialRelocationErrStates });
  const [allStatesData, setAllStatesData] = useState([]);
  const [allLGAsData, setAllLGAsData] = useState([]);
  const [filterOptions, setFilterOptions] = useState("");
  const [filters, setFilters] = useState({});
  const [lgiTableData, setLgiTableData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(1);

  const [selectedState, setSelectedState] = useState(false);

  const pageSize = 10;
  const debouncedSearchText = useDebounce(searchText, 300);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
    note: false,
  });
  const [alertDialog, setAlertDialog] = useState({
    isOpen: false,
    isLoading: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
    note: false,
    isSuccessful:false,
    isLoad:false,
  });
  const options = [
    {
      name: "status",
      type: "radio",
      group: "Status",
      options: [
        {
          label: "All",
          value: "",
        },
        {
          label: "Active",
          value: true,
        },
        {
          label: "Inactive",
          value: false,
        },
      ],
    },
    {
      type: "autocomplete",
      name: "states",
      group: "Select States",
      options: [],
    },
  ];

  const changePage = (data) => {
    let newPage = data.page + 1;
    setPageNumber(newPage);
  };

  useEffect(() => {
    let params = {};
    params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      Search: debouncedSearchText,
      "FilterOptions.Status": filterOptions.status,
      "FilterOptions.State": filterOptions.states,
    };
    //  }
    dispatch(fetchAllLGIUsers(params));
  }, [dispatch, pageNumber, pageSize, debouncedSearchText, filterOptions]);

  // effect used to populate table data
  useEffect(() => {
    if (LGIUsers && Object.keys(LGIUsers)?.length !== 0) {
      const createTableData = () => {
        let lgiTableData = [];
        let LGIUsersData = LGIUsers?.data;

        LGIUsersData?.map((val) => {
          let row = [
            val.firstName + " " + val.lastName,
            val.email,
            val.staffNo,
            val.phoneNumber,
            val.state,
            val.lga,
            !val.isDisengaged,
            val,
          ];
          return lgiTableData.push(row);
        });
        setLgiTableData(lgiTableData);
      };
      Object.keys(LGIUsers)?.length > 0 && createTableData();
    } else {
      // setLgiTableData([]);
    }
  }, [LGIUsers, pageNumber]);
  const handleBlurEmail = (event) => {
    let newValue = event.target.value;
    newValue = event.target.value.trim();
    if (!validators.isValidEmail(newValue)) {
      setError((prevError) => ({
        ...prevError,
        emailErr: true,
        emailErrText: "Please enter a valid email or clear your selection",
      }));
      return false;
    }
    setError((prevError) => ({
      ...prevError,
      emailErr: false,
      emailErrText: "",
    }));
  };

  const handleBlurPhoneNumber = (event) => {
    let newValue = event.target.value;
    newValue = event.target.value.trim();
    if (!validators.isPhoneLength(newValue)) {
      setError((prevError) => ({
        ...prevError,
        phoneNumberErr: true,
        phoneNumberErrText:
          "Please enter a valid phone number or clear your selection",
      }));
      return false;
    } else if (newValue === "") {
      setError((prevError) => ({
        ...prevError,
        phoneNumberErr: false,
        phoneNumberErrText: "",
      }));
    }
  };

  const handleChange = (prop) => (event) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [prop]: event.target.value,
    }));
    setError((prevError) => ({
      ...prevError,
      [`${prop}Err`]: false,
      [`${prop}ErrText`]: "",
    }));
  };

  const handleChangeSelectedLGA = (e) => {
    setSelectedLgaValue({ title: e.title, value: e.value });
    setFormValuesRelocate({
      ...formValuesRelocate,
      lgaId: e.value,
    });

    setNewErr({ ...newErr, lgaIdErr: false, lgaIdErrText: "" });
  };
  const handleStateChange = (e) => {
    setSelectedState(false);
    let stateCode = e.value;
    setStateValue(e);
    setFormValues({
      ...formValues,
      stateId: stateCode,
      lgaId: "",
    });
    setError({ ...error, stateIdErr: false, stateIdErrText: "" });
    setLgaValue({ title: "", value: "" });
  };

  const handleCurrentState = (e) => {
    setSelectedState(true);
    setSelectedStateValue(e);
    setFormValuesRelocate({
      ...formValuesRelocate,
      stateId: e.value,
    });
    setSelectedLgaValue({ title: "", value: "" });
    setNewErr({ ...newErr, stateIdErr: false, stateIdErrText: "" });
  };

  const fireApi = useCallback(() => {
    if (statesfetched && statesfetched?.length === 0) {
      dispatch(fetchStates());
    }
  }, [dispatch, statesfetched]);
  useEffect(() => {
    const allStatesData = statesfetched?.map(
      ({ stateName: title, stateID: value }) => ({ title, value })
    );
    setAllStatesData(allStatesData);
  }, [statesfetched]);

  useEffect(() => {
    setAllLGAsData([]);
    const filteredLgas = !selectedState
      ? statesfetched?.filter((lga) => lga?.stateID === stateValue?.value)
      : statesfetched?.filter(
          (lga) => lga?.stateID === selectedStateValue?.value
        );
    const lgaArray = filteredLgas
      .map((lga) => lga.lgas)
      .flat()
      .map((lga) => ({ value: lga.lgaid, title: lga.lgaName }));

    setAllLGAsData(lgaArray);
  }, [
    stateValue?.value,
    statesfetched,
    selectedStateValue?.value,
    selectedState,
  ]);


  const activateLGIHandler = (id) => {
    dispatch(engageLGI(id));
  };

  const deactivateLGIHandler = (id) => {
    dispatch(disengageLGI(id));
  };

  const handleSubmit = (type) => {
    const fieldsToValidate = [
      "stateId",
      "firstName",
      "lastName",
      "lgaId",
      "staffNo",
      "phoneNumber",
      "email",
    ];
    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      if (formValues[field] === "" || formValues[field] === 0) {
        newErrors[`${field}Err`] = true;
        newErrors[`${field}ErrText`] = "Field is required";
      }
    });

    if (Object.keys(newErrors)?.length > 0) {
      setError({ ...error, ...newErrors });
    } else {
      setError({ ...initialFormErrStates });
      dispatch(registerLGIUser(formValues));
    }
  };

  let formContent = [
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      md: 6,
      value: formValues.firstName,
      onChange: handleChange("firstName"),
      helperText: error.firstNameErrText,
      error: error.firstNameErr,
    },
    {
      name: "lastName",
      label: "Last Name",
      type: "text",
      md: 6,
      value: formValues.lastName,
      onChange: handleChange("lastName"),
      helperText: error.lastNameErrText,
      error: error.lastNameErr,
    },

    {
      name: "email",
      label: "Email Address",
      type: "email",
      md: 12,
      value: formValues.email,
      onChange: handleChange("email"),
      error: error.emailErr,
      helperText: error.emailErrText,
      onBlur: handleBlurEmail,
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      type: "number",
      md: 6,
      value: formValues.phoneNumber,
      onChange: handleChange("phoneNumber"),
      error: error.phoneNumberErr,
      helperText: error.phoneNumberErrText,
      onBlur: handleBlurPhoneNumber,
    },
    {
      name: "staffNo",
      label: "Staff No",
      type: "text",
      md: 6,
      value: formValues.staffNo,
      onChange: handleChange("staffNo"),
      error: error.staffNoErr,
      helperText: error.staffNoErrText,
    },
    {
      name: "state",
      label: "State",
      type: "asynchronous",
      md: 6,
      options: allStatesData,
      onChange: (e) => handleStateChange(e),
      value: stateValue,
      helperText: error.stateIdErrText,
      error: error.stateIdErr,
      dispatchAction: fireApi,
    },
    {
      name: "lga",
      label: "LGA",
      type: "asynchronous",
      md: 6,
      options: allLGAsData,
      value: lgaValue,
      onChange: (e) => {
        setLgaValue({ title: e.title, value: e.value });
        setFormValues({ ...formValues, lgaId: e.value });
        setError({ ...error, lgaIdErr: false, lgaIdErrText: "" });
      },
      helperText: error.lgaIdErrText,
      error: error.lgaIdErr,
    },
  ];

  const handleClickOpen = (type, data) => {
    if (type === "view" || type === "relocate") {
      setFormValues({
        ...formValues,
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        phoneNumber: data?.phoneNumber,
        stateId: data?.stateId,
        lgaId: data?.lgaId,
        staffNo: data?.staffNo,
      });
      setStateValue({ title: data?.state, value: data?.stateId });
      setLgaValue({ title: data?.lga, value: data?.lgaId });
      setFormValuesRelocate({
        ...formValuesRelocate,
        currentState: data?.state,
        userId: data?.id,
      });
    }
    type === "add" ? setIsView(false) : setIsView(true);
    if (type !== "relocate") {
      setOpen(true);
      setOpenRelocateDialog(false);
    } else {
      setOpenRelocateDialog(true);
    }
  };
  const resetForm = () => {
    setFormValues({ ...initialFormValues });
    setStateValue({ title: "", value: "" });
    setLgaValue({ title: "", value: "" });
    setFormValuesRelocate({ ...initialFormValuesRelocate });
    setError({ ...initialFormErrStates });
    setNewErr({ ...initialRelocationErrStates });
    setSelectedStateValue({ title: "", value: "" });
    setSelectedLgaValue({ title: "", value: "" });
    setConfirmDialog({
      ...confirmDialog,
      isLoading: false,
      isOpen: false,
    });
  };
  const handleConfirm = () => {
    setConfirmDialog({
      ...confirmDialog,
      isLoading: true,
    });
  };

  const handleStuff=()=>{
    setAlertDialog({
      ...alertDialog,
      isLoading: true,
      isSuccessful:passwordReset,
      isOpen:true,
        header:  'Resetting LGI Password...',
        // title: <p>Are you sure you want to reset the password for  <b>{value.firstName + " " + value.lastName}</b>?</p>,
        backgroundColor: colors.errorDialogBg,
        borderSideColor: colors.darkerErrorDialog,
        color: colors.darkerErrorDialog,
        subColor: colors.darkerErrorDialog,
      
    });

  }

  
  const handleFormUpdate = (type) => {
    const fieldsToValidate = ["stateId", "lgaId"];
    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      if (formValuesRelocate[field] === "" || formValuesRelocate[field] === 0) {
        newErrors[`${field}Err`] = true;
        newErrors[`${field}ErrText`] =
          "Please choose a place of relocation to submit";
      }
    });

    if (Object.keys(newErrors)?.length > 0) {
      setNewErr({ ...error, ...newErrors });
    } else {
      setError({ ...initialFormErrStates });
      const { currentState, ...remainingFormValues } = formValuesRelocate;
      setConfirmDialog({
        isOpen: true,
        note: true,
        title: (
          <b style={{ color: colors.black, fontSize: "16px" }}>
            Are you sure you want to relocate{" "}
            {formValues?.firstName + " " + formValues?.lastName} to{" "}
            {selectedLgaValue?.title},{selectedStateValue?.title}?
          </b>
        ),
        header: `Relocate LGI`,
        subTitle: (
          <p>
            You are about to relocate this LGI from{" "}
            <b style={{ color: colors.darkRed }}>
              {stateValue?.title}, {lgaValue?.title}{" "}
            </b>
            to{" "}
            <b style={{ color: colors.darkGreen }}>
              {selectedLgaValue?.title}, {selectedStateValue?.title}
            </b>
          </p>
        ),
        backgroundColor: colors.lightWarningColor,
        borderSideColor: colors.primaryYellow,
        color: colors.primaryYellow,
        subColor: colors.black,
        onConfirm: () => {
          handleConfirm();
          dispatch(relocateLGI(remainingFormValues));
        },
      });
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenRelocateDialog(false);
    resetForm();
  };

  const handleSearch = (e) => {
    let searchValue = e.target.value;
    setSearchText(searchValue);
  };

  const handleFilterClick = (event) => {
    if (event !== 0) {
      setFilters(event);
      setFilterOptions(event);
    }
  };

  const handleReset = (event) => {
    if (filterOptions !== "") {
      setFilterOptions("");
      setFilters("");
    }
  };

  useEffect(() => {
    if (registeredLGI || relocatedLGI || lgiActivated || lgiDeactivated) {
      handleClose();
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        "FilterOptions.Status": filterOptions.status,
      };
      dispatch(fetchAllLGIUsers(params));
    }
    return () => {
      dispatch(restoreLGIUser());
    };
  }, [registeredLGI, relocatedLGI, lgiActivated,lgiDeactivated]);


  useEffect(()=>{
    if(passwordReset === true){
      setAlertDialog({
        ...alertDialog,
          header:  'Reset Password Successfully',
          title: <p>Password was successfully reset for LGI </p>,
          isLoading: false,
          isLoad:true,
          // color:"#E1EDE8",
          isSuccessful:resetPassword,
      });
      return () => {
        dispatch(restoreLGIUser());
        // setAlertDialog({
        //   ...alertDialog,
        // });
      };
    }
  },[passwordReset, resettingPassword, dispatch])
  const modalContent = {
    title: isView ? "View User" : "Add User",
    content: <Forms formContent={formContent} spacing={3} readOnly={isView} />,
    footer: {
      ...(!isView && {
        action: "Add User",
      }),
    },
    onClick: handleSubmit,
    button: {
      loading: registeringLGI,
    },
  };
  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        sort: true,
        setCellProps: () => ({ style: { minWidth: "200px", padding: "20px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              <span style={{ marginLeft: "20px" }}>{column.label}</span>
            </Typography>
          );
        },
      },
    },
    {
      name: "email",
      label: "Email Address",
      options: {
        setCellProps: () => ({ style: { minWidth: "230px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "staffNo",
      label: "Staff No",
      options: {
        setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "state",
      label: "State",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "lga",
      label: "LGA",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        sort: false,
        setCellProps: () => ({ style: { minWidth: "120px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          switch (value) {
            case true:
              return (
                <StatusGenerator statusText="Active" variant="greenFilled" />
              );
            case false:
              return (
                <StatusGenerator statusText="Inactive" variant="redFilled" />
              );
            default:
              return "no status";
          }
        },
        filter: true,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        setCellProps: () => ({ style: { minWidth: "140px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Tooltip title={"View Users"}>
                <IconButton
                  size="small"
                  onClick={() => handleClickOpen("view", value)}
                >
                  <ViewIcon icon="material-symbols:visibility-outline" />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Transfer LGI"}>
                <IconButton
                  size="small"
                  onClick={() => handleClickOpen("relocate", value)}
                >
                  <EditIcon icon="mdi:transit-transfer" />
                </IconButton>
              </Tooltip>
              {value.isDisengaged? <Tooltip title={"Activate LGI"}>
                <IconButton
                  size="small"
                  onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        header: 'Activate LGI',
                        title: `Are you sure you want to activate  ${value.firstName + " " + value.lastName}?`,
                        backgroundColor: colors.successDialogBg,
                        borderSideColor: colors.darkSuccessDialog,
                        color: colors.primaryGreen,
                        subColor: colors.successDialogSubTitle,
                        onConfirm: () => {
                          handleConfirm();
                          activateLGIHandler(value.id);
                        },
                      })
                    }
                >
                 <ActivateIcon icon="fluent-mdl2:activate-orders" />
                </IconButton>
              </Tooltip>: <Tooltip title={"Deactivate LGI"}>
                <IconButton
                  size="small"
                  onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        header: 'Deactivate LGI',
                        title: `Are you sure you want to deactivate  ${value.firstName + " " + value.lastName}?`,
                        backgroundColor: colors.errorDialogBg,
                        borderSideColor: colors.darkerErrorDialog,
                        color: colors.darkerErrorDialog,
                        subColor: colors.darkerErrorDialog,
                        onConfirm: () => {
                          handleConfirm();
                          deactivateLGIHandler(value.id);
                        },
                      })
                    }
                >
                   <DeactivateIcon icon="fluent-mdl2:deactivate-orders" />
                </IconButton>
              </Tooltip>}
              <Tooltip title={"Reset LGI Password"}>
                <IconButton
                   onClick={() =>
                    setAlertDialog({
                      isOpen: true,
                      header:  'Reset LGI Password',
                      title: <p>Are you sure you want to reset the password for  <b>{value.firstName + " " + value.lastName}</b>?</p>,
                      backgroundColor: colors.errorDialogBg,
                      borderSideColor: colors.darkerErrorDialog,
                      color: colors.darkerErrorDialog,
                      subColor: colors.darkerErrorDialog,
                      onConfirm: () => {
                       handleStuff();
                     
                        dispatch(resetPassword(value.id));
                      },
                    })
                  }
                >
                  <AwardIcon icon="ic:baseline-lock-reset" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  return (
    <Page title="SAED | Skill Set Up">
      <Container maxWidth="xl">
        <Box sx={{ pb: 2 }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 600, color: "#212B36" }}
          >
            User Management
          </Typography>
        </Box>
        <Box sx={{ pb: 2 }}>
          <Grid container spacing={3}>
            {["All LGIs", "Active LGIs", "Inactive LGIs"].map((item) => (
              <Grid item md xs={12} key={item}>
                <CardAllUsers users={item} />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Paper
                sx={{
                  boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                  borderRadius: "20px",
                }}
              >
                <Card
                  elevation={0}
                  sx={{ padding: "0px !important", borderRadius: "20px" }}
                >
                  <CardContent sx={{ padding: "0px !important" }}>
                    <DataTable
                      tableName={"Users"}
                      searchPlaceHolder={"Users"}
                      actionButtons={
                        <ElevatedGreenButton
                          onClick={() => handleClickOpen("add")}
                          startIcon={<AddOutlinedIcon />}
                        >
                          Add New User
                        </ElevatedGreenButton>
                      }
                      data={lgiTableData}
                      columns={columns}
                      download={false}
                      noOtherActions={true}
                      loading={registeringLGI || fetchingLGIUsers || activatingLGI || deactivatingLGI}
                      page={pageNumber - 1}
                      changePage={changePage}
                      count={LGIUsers?.meta?.totalCount}
                      showNoDataMessage={
                        LGIUsers?.length === 0 && !fetchingLGIUsers
                      }
                      onSearch={handleSearch}
                      searchText={searchText}
                      filter={{
                        options: options,
                        filters: filters,
                        handleFilterClick: handleFilterClick,
                        handleReset: handleReset,
                      }}
                      style={{ transition: "0.7s" }}
                    />
                  </CardContent>
                </Card>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Modal open={open} handleClose={handleClose} content={modalContent} />
      <UserDialog
        title={{ left: "LGI Profile", right: "Relocate LGI" }}
        open={openRelocateDialog}
        handleClose={handleClose}
        loadingButton={relocatingLGI}
        handleFormUpdate={handleFormUpdate}
        showSkeleton={false}
        formValues={formValuesRelocate}
        stateValue={selectedStateValue}
        fireApi={fireApi}
        handleChange={handleCurrentState}
        error={newErr}
        data={{
          states: allStatesData,
          lgas: allLGAsData,
          action: handleChangeSelectedLGA,
        }}
        values={formValues}
        lga={lgaValue?.title}
        lgaValue={selectedLgaValue}
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
        <AlertDialog
        alertDialog={alertDialog}
        setAlertDialog={setAlertDialog}
      />
    </Page>
  );
};

export default UserManagement;
